import { differenceInSeconds, intervalToDuration, isAfter } from "date-fns";

export const EXPIRED_TEXT = "Diese Aktion ist leider abgelaufen";

export function getCountdownText(activeUntil: Date, expirationCallBack: () => void): string {
	const now = new Date();
	const durationInSeconds = differenceInSeconds(activeUntil, now);
	const duration = isAfter(activeUntil, now) ? intervalToDuration({ start: now, end: activeUntil }) : {};

	if ((duration.days === undefined || duration.days === 0) && durationInSeconds >= 1) {
		const hours_string = duration.hours !== undefined && duration.hours > 0 ? `${duration.hours}h` : "";
		const minutes_string = duration.minutes !== undefined && duration.minutes > 0 ? `${duration.minutes}m` : "";
		const seconds_string = duration.seconds !== undefined && duration.seconds > 0 ? `${duration.seconds}s` : "";

		return ["nur noch", hours_string, minutes_string, seconds_string].filter(Boolean).join(" ");
	}
	if (durationInSeconds < 1) {
		expirationCallBack();
		return EXPIRED_TEXT;
	}

	return "";
}
